module.exports = __webpack_public_path__ + "img/clicksLandings.145ea032.svg";